class q {
  open(n) {
    window.location.href = n;
  }
  reload() {
    window.location.reload();
  }
  getCurrentHref() {
    return window.location.href;
  }
  getPath() {
    const n = window.location;
    return n.pathname + (n.search || "") + (n.hash || "");
  }
  getOrigin() {
    return window.origin;
  }
}
const ce = 2e3, D = console;
class Ne {
  constructor(n, s, t, o = ce, i = !0) {
    this._callback = n, this._client_id = s, this._url = t, this._interval = o || ce, this._stopOnError = i;
    const r = t.indexOf("/", t.indexOf("//") + 2);
    this._frame_origin = t.substring(0, r), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.width = 0, this._frame.height = 0, this._frame.src = t;
  }
  load() {
    return new Promise((n) => {
      this._frame.onload = () => {
        n();
      }, window.document.body.appendChild(this._frame), this._boundMessageEvent = this._message.bind(this), window.addEventListener("message", this._boundMessageEvent, !1);
    });
  }
  _message(n) {
    n.origin === this._frame_origin && n.source === this._frame.contentWindow && (n.data === "error" ? (D.error("CheckSessionIFrame: error message from check session op iframe"), this._stopOnError && this.stop()) : n.data === "changed" ? (D.debug(n), D.debug("CheckSessionIFrame: changed message from check session op iframe"), this.stop(), this._callback()) : D.debug("CheckSessionIFrame: " + n.data + " message from check session op iframe"));
  }
  start(n) {
    D.debug("CheckSessionIFrame.start :" + n), this.stop();
    const s = () => {
      this._frame.contentWindow.postMessage(
        this._client_id + " " + n,
        this._frame_origin
      );
    };
    s(), this._timer = window.setInterval(s, this._interval);
  }
  stop() {
    this._timer && (D.debug("CheckSessionIFrame.stop"), window.clearInterval(this._timer), this._timer = null);
  }
}
const k = {
  service_worker_not_supported_by_browser: "service_worker_not_supported_by_browser",
  token_acquired: "token_acquired",
  logout_from_another_tab: "logout_from_another_tab",
  logout_from_same_tab: "logout_from_same_tab",
  token_renewed: "token_renewed",
  token_timer: "token_timer",
  loginAsync_begin: "loginAsync_begin",
  loginAsync_error: "loginAsync_error",
  loginCallbackAsync_begin: "loginCallbackAsync_begin",
  loginCallbackAsync_end: "loginCallbackAsync_end",
  loginCallbackAsync_error: "loginCallbackAsync_error",
  refreshTokensAsync_begin: "refreshTokensAsync_begin",
  refreshTokensAsync: "refreshTokensAsync",
  refreshTokensAsync_end: "refreshTokensAsync_end",
  refreshTokensAsync_error: "refreshTokensAsync_error",
  refreshTokensAsync_silent_error: "refreshTokensAsync_silent_error",
  tryKeepExistingSessionAsync_begin: "tryKeepExistingSessionAsync_begin",
  tryKeepExistingSessionAsync_end: "tryKeepExistingSessionAsync_end",
  tryKeepExistingSessionAsync_error: "tryKeepExistingSessionAsync_error",
  silentLoginAsync_begin: "silentLoginAsync_begin",
  silentLoginAsync: "silentLoginAsync",
  silentLoginAsync_end: "silentLoginAsync_end",
  silentLoginAsync_error: "silentLoginAsync_error",
  syncTokensAsync_begin: "syncTokensAsync_begin",
  syncTokensAsync_lock_not_available: "syncTokensAsync_lock_not_available",
  syncTokensAsync_end: "syncTokensAsync_end",
  syncTokensAsync_error: "syncTokensAsync_error",
  tokensInvalidAndWaitingActionsToRefresh: "tokensInvalidAndWaitingActionsToRefresh"
}, P = (e, n = sessionStorage) => {
  const s = (y) => (n[`oidc.${e}`] = JSON.stringify({ tokens: null, status: y }), Promise.resolve()), t = async () => {
    if (!n[`oidc.${e}`])
      return n[`oidc.${e}`] = JSON.stringify({ tokens: null, status: null }), { tokens: null, status: null };
    const y = JSON.parse(n[`oidc.${e}`]);
    return Promise.resolve({ tokens: y.tokens, status: y.status });
  }, o = (y) => {
    n[`oidc.${e}`] = JSON.stringify({ tokens: y });
  }, i = async (y) => {
    n[`oidc.session_state.${e}`] = y;
  }, r = async () => n[`oidc.session_state.${e}`], a = (y) => {
    n[`oidc.nonce.${e}`] = y.nonce;
  }, c = (y) => {
    n[`oidc.jwk.${e}`] = JSON.stringify(y);
  }, l = () => JSON.parse(n[`oidc.jwk.${e}`]), d = async () => ({ nonce: n[`oidc.nonce.${e}`] }), u = async (y) => {
    n[`oidc.dpop_nonce.${e}`] = y;
  }, _ = () => n[`oidc.dpop_nonce.${e}`], f = () => n[`oidc.${e}`] ? JSON.stringify({ tokens: JSON.parse(n[`oidc.${e}`]).tokens }) : null, h = {};
  return {
    clearAsync: s,
    initAsync: t,
    setTokens: o,
    getTokens: f,
    setSessionStateAsync: i,
    getSessionStateAsync: r,
    setNonceAsync: a,
    getNonceAsync: d,
    setLoginParams: (y) => {
      h[e] = y, n[`oidc.login.${e}`] = JSON.stringify(y);
    },
    getLoginParams: () => {
      const y = n[`oidc.login.${e}`];
      return y ? (h[e] || (h[e] = JSON.parse(y)), h[e]) : (console.warn(
        `storage[oidc.login.${e}] is empty, you should have an bad OIDC or code configuration somewhere.`
      ), null);
    },
    getStateAsync: async () => n[`oidc.state.${e}`],
    setStateAsync: async (y) => {
      n[`oidc.state.${e}`] = y;
    },
    getCodeVerifierAsync: async () => n[`oidc.code_verifier.${e}`],
    setCodeVerifierAsync: async (y) => {
      n[`oidc.code_verifier.${e}`] = y;
    },
    setDemonstratingProofOfPossessionNonce: u,
    getDemonstratingProofOfPossessionNonce: _,
    setDemonstratingProofOfPossessionJwkAsync: c,
    getDemonstratingProofOfPossessionJwkAsync: l
  };
};
var V = /* @__PURE__ */ ((e) => (e.AutomaticBeforeTokenExpiration = "AutomaticBeforeTokensExpiration", e.AutomaticOnlyWhenFetchExecuted = "AutomaticOnlyWhenFetchExecuted", e))(V || {});
const xe = (e) => decodeURIComponent(
  Array.prototype.map.call(atob(e), (n) => "%" + ("00" + n.charCodeAt(0).toString(16)).slice(-2)).join("")
), We = (e) => JSON.parse(xe(e.replaceAll(/-/g, "+").replaceAll(/_/g, "/"))), le = (e) => {
  try {
    return e && Le(e, ".") === 2 ? We(e.split(".")[1]) : null;
  } catch (n) {
    console.warn(n);
  }
  return null;
}, Le = (e, n) => e.split(n).length - 1, z = {
  access_token_or_id_token_invalid: "access_token_or_id_token_invalid",
  access_token_invalid: "access_token_invalid",
  id_token_invalid: "id_token_invalid"
};
function De(e, n, s) {
  if (e.issuedAt) {
    if (typeof e.issuedAt == "string")
      return parseInt(e.issuedAt, 10);
  } else return n && n.iat ? n.iat : s && s.iat ? s.iat : (/* @__PURE__ */ new Date()).getTime() / 1e3;
  return e.issuedAt;
}
const te = (e, n = null, s) => {
  if (!e)
    return null;
  let t;
  const o = typeof e.expiresIn == "string" ? parseInt(e.expiresIn, 10) : e.expiresIn;
  e.accessTokenPayload !== void 0 ? t = e.accessTokenPayload : t = le(e.accessToken);
  let i;
  n != null && "idToken" in n && !("idToken" in e) ? i = n.idToken : i = e.idToken;
  const r = e.idTokenPayload ? e.idTokenPayload : le(i), a = r && r.exp ? r.exp : Number.MAX_VALUE, c = t && t.exp ? t.exp : e.issuedAt + o;
  e.issuedAt = De(e, t, r);
  let l;
  e.expiresAt ? l = e.expiresAt : s === z.access_token_invalid ? l = c : s === z.id_token_invalid ? l = a : l = a < c ? a : c;
  const d = {
    ...e,
    idTokenPayload: r,
    accessTokenPayload: t,
    expiresAt: l,
    idToken: i
  };
  if (n != null && "refreshToken" in n && !("refreshToken" in e)) {
    const u = n.refreshToken;
    return { ...d, refreshToken: u };
  }
  return d;
}, oe = (e, n, s) => {
  if (!e)
    return null;
  if (!e.issued_at) {
    const o = (/* @__PURE__ */ new Date()).getTime() / 1e3;
    e.issued_at = o;
  }
  const t = {
    accessToken: e.access_token,
    expiresIn: e.expires_in,
    idToken: e.id_token,
    scope: e.scope,
    tokenType: e.token_type,
    issuedAt: e.issued_at
  };
  return "refresh_token" in e && (t.refreshToken = e.refresh_token), e.accessTokenPayload !== void 0 && (t.accessTokenPayload = e.accessTokenPayload), e.idTokenPayload !== void 0 && (t.idTokenPayload = e.idTokenPayload), te(t, n, s);
}, K = (e, n) => {
  const s = (/* @__PURE__ */ new Date()).getTime() / 1e3, t = n - s;
  return Math.round(t - e);
}, ue = (e, n = 0) => e ? K(n, e.expiresAt) > 0 : !1, pe = async (e, n = 200, s = 50) => {
  let t = s;
  if (!e.getTokens())
    return null;
  for (; !ue(
    e.getTokens(),
    e.configuration.refresh_time_before_tokens_expiration_in_second
  ) && t > 0; ) {
    if (e.configuration.token_automatic_renew_mode == V.AutomaticOnlyWhenFetchExecuted) {
      await e.renewTokensAsync({});
      break;
    } else
      await Y({ milliseconds: n });
    t = t - 1;
  }
  return {
    isTokensValid: ue(e.getTokens()),
    tokens: e.getTokens(),
    numberWaited: t - s
  };
}, we = (e, n, s) => {
  if (e.idTokenPayload) {
    const t = e.idTokenPayload;
    if (s.issuer !== t.iss)
      return {
        isValid: !1,
        reason: `Issuer does not match (oidcServerConfiguration issuer) ${s.issuer} !== (idTokenPayload issuer) ${t.iss}`
      };
    const o = (/* @__PURE__ */ new Date()).getTime() / 1e3;
    if (t.exp && t.exp < o)
      return {
        isValid: !1,
        reason: `Token expired (idTokenPayload exp) ${t.exp} < (currentTimeUnixSecond) ${o}`
      };
    const i = 60 * 60 * 24 * 7;
    if (t.iat && t.iat + i < o)
      return {
        isValid: !1,
        reason: `Token is used from too long time (idTokenPayload iat + timeInSevenDays) ${t.iat + i} < (currentTimeUnixSecond) ${o}`
      };
    if (t.nonce && t.nonce !== n)
      return {
        isValid: !1,
        reason: `Nonce does not match (idTokenPayload nonce) ${t.nonce} !== (nonce) ${n}`
      };
  }
  return { isValid: !0, reason: "" };
}, U = function() {
  const e = typeof window > "u" ? global : window;
  return {
    setTimeout: setTimeout.bind(e),
    clearTimeout: clearTimeout.bind(e),
    setInterval: setInterval.bind(e),
    clearInterval: clearInterval.bind(e)
  };
}(), _e = "7.25.9";
let fe = null, j;
const Y = ({ milliseconds: e }) => new Promise((n) => U.setTimeout(n, e)), Ae = (e = "/") => {
  try {
    j = new AbortController(), fetch(
      `${e}OidcKeepAliveServiceWorker.json?minSleepSeconds=150`,
      { signal: j.signal }
    ).catch((t) => {
      console.log(t);
    }), Y({ milliseconds: 150 * 1e3 }).then(Ae);
  } catch (n) {
    console.log(n);
  }
}, de = () => {
  j && j.abort();
}, Re = (e = "/") => fetch(`${e}OidcKeepAliveServiceWorker.json`, {
  headers: {
    "oidc-vanilla": "true"
  }
}).then((n) => n.statusText === "oidc-service-worker").catch((n) => {
  console.log(n);
}), $e = (e) => async (n, s) => {
  s(), await n.update();
  const t = await n.unregister();
  console.log(`Service worker unregistration ${t ? "successful" : "failed"}`), await Y({ milliseconds: 2e3 }), e.reload();
}, Se = (e) => {
  const n = sessionStorage.getItem(`oidc.tabId.${e}`);
  if (n)
    return n;
  const s = globalThis.crypto.randomUUID();
  return sessionStorage.setItem(`oidc.tabId.${e}`, s), s;
}, E = (e) => (n) => new Promise(function(s, t) {
  const o = new MessageChannel();
  o.port1.onmessage = function(i) {
    i != null && i.data.error ? t(i.data.error) : s(i.data), o.port1.close(), o.port2.close();
  }, e.active.postMessage({ ...n, tabId: Se(n.configurationName) }, [
    o.port2
  ]);
}), I = async (e, n) => {
  var b;
  const s = e.service_worker_relative_url;
  if (typeof window > "u" || typeof navigator > "u" || !navigator.serviceWorker || !s || e.service_worker_activate() === !1)
    return null;
  let t = null;
  e.service_worker_register ? t = await e.service_worker_register(s) : (t = await navigator.serviceWorker.register(s), t.active && t.waiting && (console.log("Detected new service worker waiting, unregistering and reloading"), await ((b = e.service_worker_update_require_callback) == null ? void 0 : b.call(e, t, de))));
  try {
    await navigator.serviceWorker.ready, navigator.serviceWorker.controller || await E(t)({ type: "claim" });
  } catch (g) {
    return console.warn(`Failed init ServiceWorker ${g.toString()}`), null;
  }
  const o = async (g) => E(t)({ type: "clear", data: { status: g }, configurationName: n }), i = async (g, S, C) => {
    var B;
    const m = await E(t)({
      type: "init",
      data: {
        oidcServerConfiguration: g,
        where: S,
        oidcConfiguration: {
          token_renew_mode: C.token_renew_mode,
          service_worker_convert_all_requests_to_cors: C.service_worker_convert_all_requests_to_cors
        }
      },
      configurationName: n
    }), x = m.version;
    return x !== _e && (console.warn(
      `Service worker ${x} version mismatch with js client version ${_e}, unregistering and reloading`
    ), await ((B = C.service_worker_update_require_callback) == null ? void 0 : B.call(C, t, de))), {
      tokens: oe(m.tokens, null, C.token_renew_mode),
      status: m.status
    };
  }, r = (g = "/") => {
    fe == null && (fe = "not_null", Ae(g));
  }, a = (g) => E(t)({
    type: "setSessionState",
    data: { sessionState: g },
    configurationName: n
  }), c = async () => (await E(t)({
    type: "getSessionState",
    data: null,
    configurationName: n
  })).sessionState, l = (g) => (sessionStorage[`oidc.nonce.${n}`] = g.nonce, E(t)({
    type: "setNonce",
    data: { nonce: g },
    configurationName: n
  })), d = async () => {
    let S = (await E(t)({
      type: "getNonce",
      data: null,
      configurationName: n
    })).nonce;
    return S || (S = sessionStorage[`oidc.nonce.${n}`], console.warn("nonce not found in service worker, using sessionStorage")), { nonce: S };
  }, u = {};
  return {
    clearAsync: o,
    initAsync: i,
    startKeepAliveServiceWorker: () => r(e.service_worker_keep_alive_path),
    isServiceWorkerProxyActiveAsync: () => Re(e.service_worker_keep_alive_path),
    setSessionStateAsync: a,
    getSessionStateAsync: c,
    setNonceAsync: l,
    getNonceAsync: d,
    setLoginParams: (g) => {
      u[n] = g, localStorage[`oidc.login.${n}`] = JSON.stringify(g);
    },
    getLoginParams: () => {
      const g = localStorage[`oidc.login.${n}`];
      return u[n] || (u[n] = JSON.parse(g)), u[n];
    },
    getStateAsync: async () => {
      let S = (await E(t)({
        type: "getState",
        data: null,
        configurationName: n
      })).state;
      return S || (S = sessionStorage[`oidc.state.${n}`], console.warn("state not found in service worker, using sessionStorage")), S;
    },
    setStateAsync: async (g) => (sessionStorage[`oidc.state.${n}`] = g, E(t)({
      type: "setState",
      data: { state: g },
      configurationName: n
    })),
    getCodeVerifierAsync: async () => {
      let S = (await E(t)({
        type: "getCodeVerifier",
        data: null,
        configurationName: n
      })).codeVerifier;
      return S || (S = sessionStorage[`oidc.code_verifier.${n}`], console.warn("codeVerifier not found in service worker, using sessionStorage")), S;
    },
    setCodeVerifierAsync: async (g) => (sessionStorage[`oidc.code_verifier.${n}`] = g, E(t)({
      type: "setCodeVerifier",
      data: { codeVerifier: g },
      configurationName: n
    })),
    setDemonstratingProofOfPossessionNonce: async (g) => {
      await E(t)({
        type: "setDemonstratingProofOfPossessionNonce",
        data: { demonstratingProofOfPossessionNonce: g },
        configurationName: n
      });
    },
    getDemonstratingProofOfPossessionNonce: async () => (await E(t)({
      type: "getDemonstratingProofOfPossessionNonce",
      data: null,
      configurationName: n
    })).demonstratingProofOfPossessionNonce,
    setDemonstratingProofOfPossessionJwkAsync: async (g) => {
      const S = JSON.stringify(g);
      await E(t)({
        type: "setDemonstratingProofOfPossessionJwk",
        data: { demonstratingProofOfPossessionJwkJson: S },
        configurationName: n
      });
    },
    getDemonstratingProofOfPossessionJwkAsync: async () => {
      const g = await E(t)({
        type: "getDemonstratingProofOfPossessionJwk",
        data: null,
        configurationName: n
      });
      return g.demonstratingProofOfPossessionJwkJson ? JSON.parse(g.demonstratingProofOfPossessionJwkJson) : null;
    }
  };
}, R = {}, Ue = (e, n = window.sessionStorage, s) => {
  if (!R[e] && n) {
    const o = n.getItem(e);
    o && (R[e] = JSON.parse(o));
  }
  const t = 1e3 * s;
  return R[e] && R[e].timestamp + t > Date.now() ? R[e].result : null;
}, Ke = (e, n, s = window.sessionStorage) => {
  const t = Date.now();
  R[e] = { result: n, timestamp: t }, s && s.setItem(e, JSON.stringify({ result: n, timestamp: t }));
};
function Te(e) {
  return new TextEncoder().encode(e);
}
function ve(e) {
  return btoa(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+/g, "");
}
function Fe(e) {
  return encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, function(s, t) {
    return String.fromCharCode(parseInt(t, 16));
  });
}
const ie = (e) => {
  let n = "";
  return e.forEach(function(s) {
    n += String.fromCharCode(s);
  }), ve(n);
};
function he(e) {
  return ve(Fe(e));
}
const Ve = {
  importKeyAlgorithm: {
    name: "ECDSA",
    namedCurve: "P-256",
    hash: { name: "ES256" }
  },
  signAlgorithm: { name: "ECDSA", hash: { name: "SHA-256" } },
  generateKeyAlgorithm: {
    name: "ECDSA",
    namedCurve: "P-256"
  },
  digestAlgorithm: { name: "SHA-256" },
  jwtHeaderAlgorithm: "ES256"
}, Je = (e) => async (n, s, t, o, i = "dpop+jwt") => {
  switch (n = Object.assign({}, n), s.typ = i, s.alg = o.jwtHeaderAlgorithm, s.alg) {
    case "ES256":
      s.jwk = { kty: n.kty, crv: n.crv, x: n.x, y: n.y };
      break;
    case "RS256":
      s.jwk = { kty: n.kty, n: n.n, e: n.e, kid: s.kid };
      break;
    default:
      throw new Error("Unknown or not implemented JWS algorithm");
  }
  const r = {
    // @ts-ignore
    // JWT "headers" really means JWS "protected headers"
    protected: he(JSON.stringify(s)),
    // @ts-ignore
    // JWT "claims" are really a JSON-defined JWS "payload"
    payload: he(JSON.stringify(t))
  }, a = o.importKeyAlgorithm, c = !0, l = ["sign"], d = await e.crypto.subtle.importKey("jwk", n, a, c, l), u = Te(`${r.protected}.${r.payload}`), _ = o.signAlgorithm, f = await e.crypto.subtle.sign(_, d, u);
  return r.signature = ie(new Uint8Array(f)), `${r.protected}.${r.payload}.${r.signature}`;
}, Me = { sign: Je }, Be = (e) => async (n) => {
  const s = n, t = !0, o = ["sign", "verify"], i = await e.crypto.subtle.generateKey(s, t, o);
  return await e.crypto.subtle.exportKey("jwk", i.privateKey);
}, He = (e) => {
  const n = Object.assign({}, e);
  return delete n.d, n.key_ops = ["verify"], n;
}, qe = {
  generate: Be,
  neuter: He
}, je = (e) => async (n, s) => {
  let t;
  switch (n.kty) {
    case "EC":
      t = '{"crv":"CRV","kty":"EC","x":"X","y":"Y"}'.replace("CRV", n.crv).replace("X", n.x).replace("Y", n.y);
      break;
    case "RSA":
      t = '{"e":"E","kty":"RSA","n":"N"}'.replace("E", n.e).replace("N", n.n);
      break;
    default:
      throw new Error("Unknown or not implemented JWK type");
  }
  const o = await e.crypto.subtle.digest(s, Te(t));
  return ie(new Uint8Array(o));
}, Ge = { thumbprint: je }, Ye = (e) => async (n) => await qe.generate(e)(n), be = (e) => (n) => async (s, t = "POST", o, i = {}) => {
  const r = {
    // https://www.rfc-editor.org/rfc/rfc9449.html#name-concept
    jti: btoa(Xe()),
    htm: t,
    htu: o,
    iat: Math.round(Date.now() / 1e3),
    ...i
  }, a = await Ge.thumbprint(e)(
    s,
    n.digestAlgorithm
  );
  return await Me.sign(e)(
    s,
    { kid: a },
    r,
    n
  );
}, Xe = () => {
  const e = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", n = "0123456789abcdef";
  let s = 0, t = "";
  for (let o = 0; o < 36; o++)
    e[o] !== "-" && e[o] !== "4" && (s = Math.random() * 16 | 0), e[o] === "x" ? t += n[s] : e[o] === "y" ? (s &= 3, s |= 8, t += n[s]) : t += e[o];
  return t;
}, Ee = () => {
  const e = typeof window < "u" && !!window.crypto, n = e && !!window.crypto.subtle;
  return { hasCrypto: e, hasSubtleCrypto: n };
}, Q = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", ze = (e) => {
  const n = [];
  for (let s = 0; s < e.byteLength; s += 1) {
    const t = e[s] % Q.length;
    n.push(Q[t]);
  }
  return n.join("");
}, Z = (e) => {
  const n = new Uint8Array(e), { hasCrypto: s } = Ee();
  if (s)
    window.crypto.getRandomValues(n);
  else
    for (let t = 0; t < e; t += 1)
      n[t] = Math.random() * Q.length | 0;
  return ze(n);
};
function Qe(e) {
  const n = new ArrayBuffer(e.length), s = new Uint8Array(n);
  for (let t = 0; t < e.length; t++)
    s[t] = e.charCodeAt(t);
  return s;
}
function Oe(e) {
  return new Promise((n, s) => {
    crypto.subtle.digest("SHA-256", Qe(e)).then(
      (t) => n(ie(new Uint8Array(t))),
      (t) => s(t)
    );
  });
}
const Ze = (e) => {
  if (e.length < 43 || e.length > 128)
    return Promise.reject(new Error("Invalid code length."));
  const { hasSubtleCrypto: n } = Ee();
  return n ? Oe(e) : Promise.reject(new Error("window.crypto.subtle is unavailable."));
}, en = 60 * 60, nn = (e) => async (n, s = en, t = window.sessionStorage, o = 1e4) => {
  const i = `${n}/.well-known/openid-configuration`, r = `oidc.server:${n}`, a = Ue(r, t, s);
  if (a)
    return new se(a);
  const c = await M(e)(i, {}, o);
  if (c.status !== 200)
    return null;
  const l = await c.json();
  return Ke(r, l, t), new se(l);
}, M = (e) => async (n, s = {}, t = 1e4, o = 0) => {
  let i;
  try {
    const r = new AbortController();
    setTimeout(() => r.abort(), t), i = await e(n, { ...s, signal: r.signal });
  } catch (r) {
    if (r.name === "AbortError" || r.message === "Network request failed") {
      if (o <= 1)
        return await M(e)(n, s, t, o + 1);
      throw r;
    } else
      throw console.error(r.message), r;
  }
  return i;
}, ee = {
  refresh_token: "refresh_token",
  access_token: "access_token"
}, ye = (e) => async (n, s, t = ee.refresh_token, o, i = {}, r = 1e4) => {
  const a = {
    token: s,
    token_type_hint: t,
    client_id: o
  };
  for (const [u, _] of Object.entries(i))
    a[u] === void 0 && (a[u] = _);
  const c = [];
  for (const u in a) {
    const _ = encodeURIComponent(u), f = encodeURIComponent(a[u]);
    c.push(`${_}=${f}`);
  }
  const l = c.join("&");
  return (await M(e)(
    n,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: l
    },
    r
  )).status !== 200 ? { success: !1 } : {
    success: !0
  };
}, sn = (e) => async (n, s, t, o, i = {}, r, a = 1e4) => {
  for (const [f, h] of Object.entries(t))
    s[f] === void 0 && (s[f] = h);
  const c = [];
  for (const f in s) {
    const h = encodeURIComponent(f), p = encodeURIComponent(s[f]);
    c.push(`${h}=${p}`);
  }
  const l = c.join("&"), d = await M(e)(
    n,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        ...i
      },
      body: l
    },
    a
  );
  if (d.status !== 200)
    return {
      success: !1,
      status: d.status,
      demonstratingProofOfPossessionNonce: null
    };
  const u = await d.json();
  let _ = null;
  return d.headers.has(G) && (_ = d.headers.get(
    G
  )), {
    success: !0,
    status: d.status,
    data: oe(u, o, r),
    demonstratingProofOfPossessionNonce: _
  };
}, tn = (e, n) => async (s, t) => {
  t = t ? { ...t } : {};
  const o = Z(128), i = await Ze(o);
  await e.setCodeVerifierAsync(o), await e.setStateAsync(t.state), t.code_challenge = i, t.code_challenge_method = "S256";
  let r = "";
  if (t)
    for (const [a, c] of Object.entries(t))
      r === "" ? r += "?" : r += "&", r += `${a}=${encodeURIComponent(c)}`;
  n.open(`${s}${r}`);
}, G = "DPoP-Nonce", on = (e) => async (n, s, t, o, i = 1e4) => {
  s = s ? { ...s } : {}, s.code_verifier = await e.getCodeVerifierAsync();
  const r = [];
  for (const u in s) {
    const _ = encodeURIComponent(u), f = encodeURIComponent(s[u]);
    r.push(`${_}=${f}`);
  }
  const a = r.join("&"), c = await M(fetch)(
    n,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        ...t
      },
      body: a
    },
    i
  );
  if (await Promise.all([e.setCodeVerifierAsync(null), e.setStateAsync(null)]), c.status !== 200)
    return { success: !1, status: c.status };
  let l = null;
  c.headers.has(G) && (l = c.headers.get(
    G
  ));
  const d = await c.json();
  return {
    success: !0,
    data: {
      state: s.state,
      tokens: oe(d, null, o),
      demonstratingProofOfPossessionNonce: l
    }
  };
};
async function ge(e, n, s, t = null) {
  const o = (c) => {
    e.tokens = c;
  }, { tokens: i, status: r } = await H(e)(
    o,
    0,
    n,
    s,
    t
  );
  return await I(e.configuration, e.configurationName) || await P(e.configurationName, e.configuration.storage).setTokens(e.tokens), e.tokens ? i : (await e.destroyAsync(r), null);
}
async function Pe(e, n = !1, s = null, t = null) {
  const o = e.configuration, i = `${o.client_id}_${e.configurationName}_${o.authority}`;
  let r;
  const a = await I(e.configuration, e.configurationName);
  if ((o == null ? void 0 : o.storage) === (window == null ? void 0 : window.sessionStorage) && !a || !navigator.locks)
    r = await ge(e, n, s, t);
  else {
    let c = "retry";
    for (; c === "retry"; )
      c = await navigator.locks.request(
        i,
        { ifAvailable: !0 },
        async (l) => l ? await ge(e, n, s, t) : (e.publishEvent(N.eventNames.syncTokensAsync_lock_not_available, {
          lock: "lock not available"
        }), "retry")
      );
    r = c;
  }
  return r ? (e.timeoutId && (e.timeoutId = J(e, e.tokens.expiresAt, s, t)), e.tokens) : null;
}
const J = (e, n, s = null, t = null) => {
  const o = e.configuration.refresh_time_before_tokens_expiration_in_second;
  return e.timeoutId && U.clearTimeout(e.timeoutId), U.setTimeout(async () => {
    const r = { timeLeft: K(o, n) };
    e.publishEvent(N.eventNames.token_timer, r), await Pe(e, !1, s, t);
  }, 1e3);
}, W = {
  FORCE_REFRESH: "FORCE_REFRESH",
  SESSION_LOST: "SESSION_LOST",
  NOT_CONNECTED: "NOT_CONNECTED",
  TOKENS_VALID: "TOKENS_VALID",
  TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID: "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID",
  LOGOUT_FROM_ANOTHER_TAB: "LOGOUT_FROM_ANOTHER_TAB",
  REQUIRE_SYNC_TOKENS: "REQUIRE_SYNC_TOKENS"
}, rn = (e) => async (n, s, t, o = !1) => {
  const i = { nonce: null };
  if (!t)
    return { tokens: null, status: "NOT_CONNECTED", nonce: i };
  let r = i;
  const a = await e.initAsync(
    n.authority,
    n.authority_configuration
  ), c = await I(n, s);
  if (c) {
    const { status: u, tokens: _ } = await c.initAsync(
      a,
      "syncTokensAsync",
      n
    );
    if (u === "LOGGED_OUT")
      return { tokens: null, status: "LOGOUT_FROM_ANOTHER_TAB", nonce: i };
    if (u === "SESSIONS_LOST")
      return { tokens: null, status: "SESSIONS_LOST", nonce: i };
    if (!u || !_)
      return { tokens: null, status: "REQUIRE_SYNC_TOKENS", nonce: i };
    if (_.issuedAt !== t.issuedAt) {
      const h = K(
        n.refresh_time_before_tokens_expiration_in_second,
        _.expiresAt
      ) > 0 ? "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID" : "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID", p = await c.getNonceAsync();
      return { tokens: _, status: h, nonce: p };
    }
    r = await c.getNonceAsync();
  } else {
    const u = P(s, n.storage ?? sessionStorage), _ = await u.initAsync();
    let { tokens: f } = _;
    const { status: h } = _;
    if (f && (f = te(f, e.tokens, n.token_renew_mode)), f) {
      if (h === "SESSIONS_LOST")
        return { tokens: null, status: "SESSIONS_LOST", nonce: i };
      if (f.issuedAt !== t.issuedAt) {
        const w = K(
          n.refresh_time_before_tokens_expiration_in_second,
          f.expiresAt
        ) > 0 ? "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID" : "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID", T = await u.getNonceAsync();
        return { tokens: f, status: w, nonce: T };
      }
    } else return { tokens: null, status: "LOGOUT_FROM_ANOTHER_TAB", nonce: i };
    r = await u.getNonceAsync();
  }
  const d = K(
    n.refresh_time_before_tokens_expiration_in_second,
    t.expiresAt
  ) > 0 ? "TOKENS_VALID" : "TOKENS_INVALID";
  return o ? { tokens: t, status: "FORCE_REFRESH", nonce: r } : { tokens: t, status: d, nonce: r };
}, H = (e) => async (n, s = 0, t = !1, o = null, i = null) => {
  if (!navigator.onLine && document.hidden)
    return { tokens: e.tokens, status: "GIVE_UP" };
  let r = 6;
  for (; !navigator.onLine && r > 0; )
    await Y({ milliseconds: 1e3 }), r--, e.publishEvent(k.refreshTokensAsync, {
      message: `wait because navigator is offline try ${r}`
    });
  const a = document.hidden, c = a ? s : s + 1;
  if (s > 4)
    return a ? { tokens: e.tokens, status: "GIVE_UP" } : (n(null), e.publishEvent(k.refreshTokensAsync_error, { message: "refresh token" }), { tokens: null, status: "SESSION_LOST" });
  o || (o = {});
  const l = e.configuration, d = (_, f = null, h = null) => re(
    e.configurationName,
    e.configuration,
    e.publishEvent.bind(e)
  )(_, f, h), u = async () => {
    try {
      let _;
      const f = await I(l, e.configurationName);
      f ? _ = f.getLoginParams() : _ = P(e.configurationName, l.storage).getLoginParams();
      const h = await d({
        ..._.extras,
        ...o,
        prompt: "none",
        scope: i
      });
      return h ? h.error ? (n(null), e.publishEvent(k.refreshTokensAsync_error, {
        message: "refresh token silent"
      }), { tokens: null, status: "SESSION_LOST" }) : (n(h.tokens), e.publishEvent(N.eventNames.token_renewed, {}), { tokens: h.tokens, status: "LOGGED" }) : (n(null), e.publishEvent(k.refreshTokensAsync_error, {
        message: "refresh token silent not active"
      }), { tokens: null, status: "SESSION_LOST" });
    } catch (_) {
      return console.error(_), e.publishEvent(k.refreshTokensAsync_silent_error, {
        message: "exceptionSilent",
        exception: _.message
      }), await H(e)(
        n,
        c,
        t,
        o,
        i
      );
    }
  };
  try {
    const { status: _, tokens: f, nonce: h } = await rn(e)(
      l,
      e.configurationName,
      e.tokens,
      t
    );
    switch (_) {
      case W.SESSION_LOST:
        return n(null), e.publishEvent(k.refreshTokensAsync_error, {
          message: "refresh token session lost"
        }), { tokens: null, status: "SESSION_LOST" };
      case W.NOT_CONNECTED:
        return n(null), { tokens: null, status: null };
      case W.TOKENS_VALID:
        return n(f), { tokens: f, status: "LOGGED_IN" };
      case W.TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID:
        return n(f), e.publishEvent(N.eventNames.token_renewed, {
          reason: "TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID"
        }), { tokens: f, status: "LOGGED_IN" };
      case W.LOGOUT_FROM_ANOTHER_TAB:
        return n(null), e.publishEvent(k.logout_from_another_tab, {
          status: "session syncTokensAsync"
        }), { tokens: null, status: "LOGGED_OUT" };
      case W.REQUIRE_SYNC_TOKENS:
        return l.token_automatic_renew_mode == V.AutomaticOnlyWhenFetchExecuted && W.FORCE_REFRESH !== _ ? (e.publishEvent(k.tokensInvalidAndWaitingActionsToRefresh, {}), { tokens: e.tokens, status: "GIVE_UP" }) : (e.publishEvent(k.refreshTokensAsync_begin, { tryNumber: s }), await u());
      default: {
        if (l.token_automatic_renew_mode == V.AutomaticOnlyWhenFetchExecuted && W.FORCE_REFRESH !== _)
          return e.publishEvent(k.tokensInvalidAndWaitingActionsToRefresh, {}), { tokens: e.tokens, status: "GIVE_UP" };
        if (e.publishEvent(k.refreshTokensAsync_begin, {
          refreshToken: f.refreshToken,
          status: _,
          tryNumber: s
        }), !f.refreshToken)
          return await u();
        const p = l.client_id, w = l.redirect_uri, T = l.authority, A = { ...l.token_request_extras ? l.token_request_extras : {} };
        for (const [y, b] of Object.entries(o))
          y.endsWith(":token_request") && (A[y.replace(":token_request", "")] = b);
        return await (async () => {
          const y = {
            client_id: p,
            redirect_uri: w,
            grant_type: "refresh_token",
            refresh_token: f.refreshToken
          }, b = await e.initAsync(
            T,
            l.authority_configuration
          ), g = document.hidden ? 1e4 : 3e4 * 10, S = b.tokenEndpoint, C = {};
          l.demonstrating_proof_of_possession && (C.DPoP = await e.generateDemonstrationOfProofOfPossessionAsync(
            f.accessToken,
            S,
            "POST"
          ));
          const m = await sn(e.getFetch())(
            S,
            y,
            A,
            f,
            C,
            l.token_renew_mode,
            g
          );
          if (m.success) {
            const { isValid: x, reason: B } = we(
              m.data,
              h.nonce,
              b
            );
            if (!x)
              return n(null), e.publishEvent(k.refreshTokensAsync_error, {
                message: `refresh token return not valid tokens, reason: ${B}`
              }), { tokens: null, status: "SESSION_LOST" };
            if (n(m.data), m.demonstratingProofOfPossessionNonce) {
              const ae = await I(l, e.configurationName);
              ae ? await ae.setDemonstratingProofOfPossessionNonce(
                m.demonstratingProofOfPossessionNonce
              ) : await P(e.configurationName, l.storage).setDemonstratingProofOfPossessionNonce(
                m.demonstratingProofOfPossessionNonce
              );
            }
            return e.publishEvent(k.refreshTokensAsync_end, {
              success: m.success
            }), e.publishEvent(N.eventNames.token_renewed, { reason: "REFRESH_TOKEN" }), { tokens: m.data, status: "LOGGED_IN" };
          } else
            return e.publishEvent(k.refreshTokensAsync_silent_error, {
              message: "bad request",
              tokenResponse: m
            }), m.status >= 400 && m.status < 500 ? (n(null), e.publishEvent(k.refreshTokensAsync_error, {
              message: `session lost: ${m.status}`
            }), { tokens: null, status: "SESSION_LOST" }) : await H(e)(
              n,
              c,
              t,
              o,
              i
            );
        })();
      }
    }
  } catch (_) {
    return console.error(_), e.publishEvent(k.refreshTokensAsync_silent_error, {
      message: "exception",
      exception: _.message
    }), new Promise((f, h) => {
      setTimeout(() => {
        H(e)(n, c, t, o, i).then(f).catch(h);
      }, 1e3);
    });
  }
}, re = (e, n, s) => (t = null, o = null, i = null) => {
  if (!n.silent_redirect_uri || !n.silent_login_uri)
    return Promise.resolve(null);
  try {
    s(k.silentLoginAsync_begin, {});
    let r = "";
    if (o && (t == null && (t = {}), t.state = o), i != null && (t == null && (t = {}), t.scope = i), t != null)
      for (const [u, _] of Object.entries(t))
        r === "" ? r = `?${encodeURIComponent(u)}=${encodeURIComponent(_)}` : r += `&${encodeURIComponent(u)}=${encodeURIComponent(_)}`;
    const a = n.silent_login_uri + r, c = a.indexOf("/", a.indexOf("//") + 2), l = a.substring(0, c), d = document.createElement("iframe");
    return d.width = "0px", d.height = "0px", d.id = `${e}_oidc_iframe`, d.setAttribute("src", a), document.body.appendChild(d), new Promise((u, _) => {
      let f = !1;
      const h = () => {
        window.removeEventListener("message", p), d.remove(), f = !0;
      }, p = (w) => {
        if (w.origin === l && w.source === d.contentWindow) {
          const T = `${e}_oidc_tokens:`, O = `${e}_oidc_error:`, A = `${e}_oidc_exception:`, v = w.data;
          if (v && typeof v == "string" && !f) {
            if (v.startsWith(T)) {
              const y = JSON.parse(w.data.replace(T, ""));
              s(k.silentLoginAsync_end, {}), u(y), h();
            } else if (v.startsWith(O)) {
              const y = JSON.parse(w.data.replace(O, ""));
              s(k.silentLoginAsync_error, y), u({ error: "oidc_" + y.error, tokens: null, sessionState: null }), h();
            } else if (v.startsWith(A)) {
              const y = JSON.parse(w.data.replace(A, ""));
              s(k.silentLoginAsync_error, y), _(new Error(y.error)), h();
            }
          }
        }
      };
      try {
        window.addEventListener("message", p);
        const w = n.silent_login_timeout;
        setTimeout(() => {
          f || (h(), s(k.silentLoginAsync_error, { reason: "timeout" }), _(new Error("timeout")));
        }, w);
      } catch (w) {
        h(), s(k.silentLoginAsync_error, w), _(w);
      }
    });
  } catch (r) {
    throw s(k.silentLoginAsync_error, r), r;
  }
}, an = (e, n, s, t, o) => (i = null, r = void 0) => {
  i = { ...i };
  const a = (l, d, u) => re(n, s, t.bind(o))(
    l,
    d,
    u
  );
  return (async () => {
    o.timeoutId && U.clearTimeout(o.timeoutId);
    let l;
    i && "state" in i && (l = i.state, delete i.state);
    try {
      const d = s.extras ? { ...s.extras, ...i } : i, u = await a(
        {
          ...d,
          prompt: "none"
        },
        l,
        r
      );
      if (u)
        return o.tokens = u.tokens, t(k.token_acquired, {}), o.timeoutId = J(o, o.tokens.expiresAt, i, r), {};
    } catch (d) {
      return d;
    }
  })();
}, cn = (e, n, s) => (t, o, i, r = !1) => {
  const a = (c, l = void 0, d = void 0) => re(e.configurationName, s, e.publishEvent.bind(e))(
    c,
    l,
    d
  );
  return new Promise((c, l) => {
    if (s.silent_login_uri && s.silent_redirect_uri && s.monitor_session && t && i && !r) {
      const d = () => {
        e.checkSessionIFrame.stop();
        const u = e.tokens;
        if (u === null)
          return;
        const _ = u.idToken, f = u.idTokenPayload;
        return a({
          prompt: "none",
          id_token_hint: _,
          scope: s.scope || "openid"
        }).then((h) => {
          if (h.error)
            throw new Error(h.error);
          const p = h.tokens.idTokenPayload;
          if (f.sub === p.sub) {
            const w = h.sessionState;
            e.checkSessionIFrame.start(h.sessionState), f.sid === p.sid ? console.debug(
              "SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:",
              w
            ) : console.debug(
              "SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:",
              w
            );
          } else
            console.debug(
              "SessionMonitor._callback: Different subject signed into OP:",
              p.sub
            );
        }).catch(async (h) => {
          console.warn(
            "SessionMonitor._callback: Silent login failed, logging out other tabs:",
            h
          );
          for (const [, p] of Object.entries(n))
            await p.logoutOtherTabAsync(s.client_id, f.sub);
        });
      };
      e.checkSessionIFrame = new Ne(
        d,
        o,
        t
      ), e.checkSessionIFrame.load().then(() => {
        e.checkSessionIFrame.start(i), c(e.checkSessionIFrame);
      }).catch((u) => {
        l(u);
      });
    } else
      c(null);
  });
}, ln = (e) => !!(e.os === "iOS" && e.osVersion.startsWith("12") || e.os === "Mac OS X" && e.osVersion.startsWith("10_15_6")), un = (e) => {
  const n = e.appVersion, s = e.userAgent, t = "-";
  let o = t;
  const i = [
    { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
    { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
    { s: "Windows Vista", r: /Windows NT 6.0/ },
    { s: "Windows Server 2003", r: /Windows NT 5.2/ },
    { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
    { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
    { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
    { s: "Windows 98", r: /(Windows 98|Win98)/ },
    { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
    { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
    { s: "Windows CE", r: /Windows CE/ },
    { s: "Windows 3.11", r: /Win16/ },
    { s: "Android", r: /Android/ },
    { s: "Open BSD", r: /OpenBSD/ },
    { s: "Sun OS", r: /SunOS/ },
    { s: "Chrome OS", r: /CrOS/ },
    { s: "Linux", r: /(Linux|X11(?!.*CrOS))/ },
    { s: "iOS", r: /(iPhone|iPad|iPod)/ },
    { s: "Mac OS X", r: /Mac OS X/ },
    { s: "Mac OS", r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { s: "QNX", r: /QNX/ },
    { s: "UNIX", r: /UNIX/ },
    { s: "BeOS", r: /BeOS/ },
    { s: "OS/2", r: /OS\/2/ },
    {
      s: "Search Bot",
      r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
    }
  ];
  for (const a in i) {
    const c = i[a];
    if (c.r.test(s)) {
      o = c.s;
      break;
    }
  }
  let r = t;
  switch (/Windows/.test(o) && (r = /Windows (.*)/.exec(o)[1], o = "Windows"), o) {
    case "Mac OS":
    case "Mac OS X":
    case "Android":
      r = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(s)[1];
      break;
    case "iOS": {
      const a = /OS (\d+)_(\d+)_?(\d+)?/.exec(n);
      a != null && a.length > 2 && (r = a[1] + "." + a[2] + "." + (parseInt(a[3]) | 0));
      break;
    }
  }
  return {
    os: o,
    osVersion: r
  };
};
function _n() {
  const e = navigator.userAgent;
  let n, s = e.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(s[1]))
    return n = /\brv[ :]+(\d+)/g.exec(e) || [], { name: "ie", version: n[1] || "" };
  if (s[1] === "Chrome" && (n = e.match(/\bOPR|Edge\/(\d+)/), n != null)) {
    let t = n[1];
    if (!t) {
      const o = e.split(n[0] + "/");
      o.length > 1 && (t = o[1]);
    }
    return { name: "opera", version: t };
  }
  return s = s[2] ? [s[1], s[2]] : [navigator.appName, navigator.appVersion, "-?"], (n = e.match(/version\/(\d+)/i)) != null && s.splice(1, 1, n[1]), {
    name: s[0].toLowerCase(),
    version: s[1]
  };
}
const fn = () => {
  const { name: e, version: n } = _n();
  if (e === "chrome" && parseInt(n) <= 70 || e === "opera" && (!n || parseInt(n.split(".")[0]) < 80) || e === "ie")
    return !1;
  const s = un(navigator);
  return !ln(s);
}, dn = async (e) => {
  let n;
  if (e.tokens != null)
    return !1;
  e.publishEvent(k.tryKeepExistingSessionAsync_begin, {});
  try {
    const s = e.configuration, t = await e.initAsync(
      s.authority,
      s.authority_configuration
    );
    if (n = await I(s, e.configurationName), n) {
      const { tokens: o } = await n.initAsync(
        t,
        "tryKeepExistingSessionAsync",
        s
      );
      if (o) {
        n.startKeepAliveServiceWorker(), e.tokens = o;
        const i = n.getLoginParams(e.configurationName);
        e.timeoutId = J(
          e,
          e.tokens.expiresAt,
          i.extras,
          i.scope
        );
        const r = await n.getSessionStateAsync();
        return await e.startCheckSessionAsync(
          t.checkSessionIframe,
          s.client_id,
          r
        ), s.preload_user_info && await e.userInfoAsync(), e.publishEvent(k.tryKeepExistingSessionAsync_end, {
          success: !0,
          message: "tokens inside ServiceWorker are valid"
        }), !0;
      }
      e.publishEvent(k.tryKeepExistingSessionAsync_end, {
        success: !1,
        message: "no exiting session found"
      });
    } else {
      s.service_worker_relative_url && e.publishEvent(k.service_worker_not_supported_by_browser, {
        message: "service worker is not supported by this browser"
      });
      const o = P(e.configurationName, s.storage ?? sessionStorage), { tokens: i } = await o.initAsync();
      if (i) {
        e.tokens = te(i, null, s.token_renew_mode);
        const r = o.getLoginParams();
        e.timeoutId = J(
          e,
          e.tokens.expiresAt,
          r.extras,
          r.scope
        );
        const a = await o.getSessionStateAsync();
        return await e.startCheckSessionAsync(
          t.checkSessionIframe,
          s.client_id,
          a
        ), s.preload_user_info && await e.userInfoAsync(), e.publishEvent(k.tryKeepExistingSessionAsync_end, {
          success: !0,
          message: "tokens inside storage are valid"
        }), !0;
      }
    }
    return e.publishEvent(k.tryKeepExistingSessionAsync_end, {
      success: !1,
      message: n ? "service worker sessions not retrieved" : "session storage sessions not retrieved"
    }), !1;
  } catch (s) {
    return console.error(s), n && await n.clearAsync(), e.publishEvent(
      k.tryKeepExistingSessionAsync_error,
      "tokens inside ServiceWorker are invalid"
    ), !1;
  }
}, Ie = (e) => {
  const n = e.match(
    // eslint-disable-next-line no-useless-escape
    /^([a-z][\w-]+\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
  );
  if (!n)
    throw new Error("Invalid URL");
  let s = n[6], t = n[7];
  if (t) {
    const o = t.split("?");
    o.length === 2 && (t = o[0], s = o[1]);
  }
  return s.startsWith("?") && (s = s.slice(1)), n && {
    href: e,
    protocol: n[1],
    host: n[2],
    hostname: n[3],
    port: n[4],
    path: n[5],
    search: s,
    hash: t
  };
}, En = (e) => {
  const n = Ie(e);
  let { path: s } = n;
  s.endsWith("/") && (s = s.slice(0, -1));
  let { hash: t } = n;
  return t === "#_=_" && (t = ""), t && (s += t), s;
}, ne = (e) => {
  const n = Ie(e), { search: s } = n;
  return hn(s);
}, hn = (e) => {
  const n = {};
  let s, t, o;
  const i = e.split("&");
  for (t = 0, o = i.length; t < o; t++)
    s = i[t].split("="), n[decodeURIComponent(s[0])] = decodeURIComponent(s[1]);
  return n;
}, yn = (e, n, s, t, o) => (i = void 0, r = null, a = !1, c = void 0) => {
  const l = r;
  return r = { ...r }, (async () => {
    const u = i || o.getPath();
    if ("state" in r || (r.state = Z(16)), s(k.loginAsync_begin, {}), r)
      for (const _ of Object.keys(r))
        _.endsWith(":token_request") && delete r[_];
    try {
      const _ = a ? n.silent_redirect_uri : n.redirect_uri;
      c || (c = n.scope);
      const f = n.extras ? { ...n.extras, ...r } : r;
      f.nonce || (f.nonce = Z(12));
      const h = { nonce: f.nonce }, p = await I(n, e), w = await t(
        n.authority,
        n.authority_configuration
      );
      let T;
      if (p)
        p.setLoginParams({ callbackPath: u, extras: l, scope: c }), await p.initAsync(w, "loginAsync", n), await p.setNonceAsync(h), p.startKeepAliveServiceWorker(), T = p;
      else {
        const A = P(e, n.storage ?? sessionStorage);
        A.setLoginParams({ callbackPath: u, extras: l, scope: c }), await A.setNonceAsync(h), T = A;
      }
      const O = {
        client_id: n.client_id,
        redirect_uri: _,
        scope: c,
        response_type: "code",
        ...f
      };
      await tn(T, o)(
        w.authorizationEndpoint,
        O
      );
    } catch (_) {
      throw s(k.loginAsync_error, _), _;
    }
  })();
}, gn = (e) => async (n = !1) => {
  try {
    e.publishEvent(k.loginCallbackAsync_begin, {});
    const s = e.configuration, t = s.client_id, o = n ? s.silent_redirect_uri : s.redirect_uri, i = s.authority, r = s.token_request_timeout, a = await e.initAsync(
      i,
      s.authority_configuration
    ), c = e.location.getCurrentHref(), l = ne(c), d = l.session_state, u = await I(s, e.configurationName);
    let _, f, h, p;
    if (u)
      await u.initAsync(a, "loginCallbackAsync", s), await u.setSessionStateAsync(d), f = await u.getNonceAsync(), h = u.getLoginParams(), p = await u.getStateAsync(), u.startKeepAliveServiceWorker(), _ = u;
    else {
      const m = P(
        e.configurationName,
        s.storage ?? sessionStorage
      );
      await m.setSessionStateAsync(d), f = await m.getNonceAsync(), h = m.getLoginParams(), p = await m.getStateAsync(), _ = m;
    }
    if (l.error || l.error_description)
      throw new Error(
        `Error from OIDC server: ${l.error} - ${l.error_description}`
      );
    if (l.iss && l.iss !== a.issuer)
      throw console.error(), new Error(
        `Issuer not valid (expected: ${a.issuer}, received: ${l.iss})`
      );
    if (l.state && l.state !== p)
      throw new Error(`State not valid (expected: ${p}, received: ${l.state})`);
    const w = {
      code: l.code,
      grant_type: "authorization_code",
      client_id: s.client_id,
      redirect_uri: o
    }, T = {};
    if (s.token_request_extras)
      for (const [m, x] of Object.entries(s.token_request_extras))
        T[m] = x;
    if (h != null && h.extras)
      for (const [m, x] of Object.entries(h.extras))
        m.endsWith(":token_request") && (T[m.replace(":token_request", "")] = x);
    const O = a.tokenEndpoint, A = {};
    if (s.demonstrating_proof_of_possession)
      if (u)
        A.DPoP = `DPOP_SECURED_BY_OIDC_SERVICE_WORKER_${e.configurationName}`;
      else {
        const m = await Ye(window)(
          s.demonstrating_proof_of_possession_configuration.generateKeyAlgorithm
        );
        await P(e.configurationName, s.storage).setDemonstratingProofOfPossessionJwkAsync(m), A.DPoP = await be(window)(
          s.demonstrating_proof_of_possession_configuration
        )(m, "POST", O);
      }
    const v = await on(_)(
      O,
      { ...w, ...T },
      A,
      e.configuration.token_renew_mode,
      r
    );
    if (!v.success)
      throw new Error("Token request failed");
    let y;
    const b = v.data.tokens, g = v.data.demonstratingProofOfPossessionNonce;
    if (v.data.state !== T.state)
      throw new Error("state is not valid");
    const { isValid: S, reason: C } = we(
      b,
      f.nonce,
      a
    );
    if (!S)
      throw new Error(`Tokens are not OpenID valid, reason: ${C}`);
    if (u) {
      if (b.refreshToken && !b.refreshToken.includes("SECURED_BY_OIDC_SERVICE_WORKER"))
        throw new Error("Refresh token should be hidden by service worker");
      if (g && (b != null && b.accessToken.includes("SECURED_BY_OIDC_SERVICE_WORKER")))
        throw new Error(
          "Demonstration of proof of possession require Access token not hidden by service worker"
        );
    }
    if (u)
      await u.initAsync(a, "syncTokensAsync", s), y = u.getLoginParams(), g && await u.setDemonstratingProofOfPossessionNonce(
        g
      );
    else {
      const m = P(e.configurationName, s.storage);
      y = m.getLoginParams(), g && await m.setDemonstratingProofOfPossessionNonce(g);
    }
    return await e.startCheckSessionAsync(
      a.checkSessionIframe,
      t,
      d,
      n
    ), e.publishEvent(k.loginCallbackAsync_end, {}), {
      tokens: b,
      state: "request.state",
      callbackPath: y.callbackPath,
      scope: l.scope,
      extras: y.extras
    };
  } catch (s) {
    throw console.error(s), e.publishEvent(k.loginCallbackAsync_error, s), s;
  }
}, ke = {
  access_token: "access_token",
  refresh_token: "refresh_token"
}, X = (e, n) => {
  const s = {};
  if (e) {
    for (const [t, o] of Object.entries(e))
      if (t.endsWith(n)) {
        const i = t.replace(n, "");
        s[i] = o;
      }
    return s;
  }
  return s;
}, kn = (e) => {
  const n = {};
  if (e) {
    for (const [s, t] of Object.entries(e))
      s.includes(":") || (n[s] = t);
    return n;
  }
  return n;
}, mn = (e) => async (n) => {
  U.clearTimeout(e.timeoutId), e.timeoutId = null, e.checkSessionIFrame && e.checkSessionIFrame.stop();
  const s = await I(e.configuration, e.configurationName);
  s ? await s.clearAsync(n) : await P(e.configurationName, e.configuration.storage).clearAsync(n), e.tokens = null, e.userInfo = null;
}, pn = (e, n, s, t, o) => async (i = void 0, r = null) => {
  var T, O;
  const a = e.configuration, c = await e.initAsync(
    a.authority,
    a.authority_configuration
  );
  i && typeof i != "string" && (i = void 0, t.warn("callbackPathOrUrl path is not a string"));
  const l = i ?? o.getPath();
  let d = !1;
  i && (d = i.includes("https://") || i.includes("http://"));
  const u = d ? i : o.getOrigin() + l, _ = e.tokens ? e.tokens.idToken : "";
  try {
    const A = c.revocationEndpoint;
    if (A) {
      const v = [], y = e.tokens ? e.tokens.accessToken : null;
      if (y && a.logout_tokens_to_invalidate.includes(ke.access_token)) {
        const g = X(r, ":revoke_access_token"), S = ye(s)(
          A,
          y,
          ee.access_token,
          a.client_id,
          g
        );
        v.push(S);
      }
      const b = e.tokens ? e.tokens.refreshToken : null;
      if (b && a.logout_tokens_to_invalidate.includes(ke.refresh_token)) {
        const g = X(r, ":revoke_refresh_token"), S = ye(s)(
          A,
          b,
          ee.refresh_token,
          a.client_id,
          g
        );
        v.push(S);
      }
      v.length > 0 && await Promise.all(v);
    }
  } catch (A) {
    t.warn(
      "logoutAsync: error when revoking tokens, if the error persist, you ay configure property logout_tokens_to_invalidate from configuration to avoid this error"
    ), t.warn(A);
  }
  const f = ((O = (T = e.tokens) == null ? void 0 : T.idTokenPayload) == null ? void 0 : O.sub) ?? null;
  await e.destroyAsync("LOGGED_OUT");
  for (const [, A] of Object.entries(n))
    A !== e ? await e.logoutSameTabAsync(e.configuration.client_id, f) : e.publishEvent(k.logout_from_same_tab, {});
  const h = X(r, ":oidc");
  if (h && h.no_reload === "true")
    return;
  const w = kn(r);
  if (c.endSessionEndpoint) {
    "id_token_hint" in w || (w.id_token_hint = _), !("post_logout_redirect_uri" in w) && i !== null && (w.post_logout_redirect_uri = u);
    let A = "";
    for (const [v, y] of Object.entries(w))
      y != null && (A === "" ? A += "?" : A += "&", A += `${v}=${encodeURIComponent(y)}`);
    o.open(`${c.endSessionEndpoint}${A}`);
  } else
    o.reload();
}, Ce = (e, n, s = !1) => async (...t) => {
  var f;
  const [o, i, ...r] = t, a = i ? { ...i } : { method: "GET" };
  let c = new Headers();
  a.headers && (c = a.headers instanceof Headers ? a.headers : new Headers(a.headers));
  const l = {
    getTokens: () => n.tokens,
    configuration: {
      token_automatic_renew_mode: n.configuration.token_automatic_renew_mode,
      refresh_time_before_tokens_expiration_in_second: n.configuration.refresh_time_before_tokens_expiration_in_second
    },
    renewTokensAsync: n.renewTokensAsync.bind(n)
  }, d = await pe(l), u = (f = d == null ? void 0 : d.tokens) == null ? void 0 : f.accessToken;
  if (c.has("Accept") || c.set("Accept", "application/json"), u) {
    if (n.configuration.demonstrating_proof_of_possession && s) {
      const h = await n.generateDemonstrationOfProofOfPossessionAsync(
        u,
        o.toString(),
        a.method
      );
      c.set("Authorization", `DPoP ${u}`), c.set("DPoP", h);
    } else
      c.set("Authorization", `Bearer ${u}`);
    a.credentials || (a.credentials = "same-origin");
  }
  const _ = { ...a, headers: c };
  return await e(o, _, ...r);
}, wn = (e) => async (n = !1, s = !1) => {
  if (e.userInfo != null && !n)
    return e.userInfo;
  const t = e.configuration, i = (await e.initAsync(
    t.authority,
    t.authority_configuration
  )).userInfoEndpoint, a = await (async () => {
    const l = await Ce(fetch, e, s)(i);
    return l.status !== 200 ? null : l.json();
  })();
  return e.userInfo = a, a;
}, An = () => fetch;
class se {
  constructor(n) {
    this.authorizationEndpoint = n.authorization_endpoint, this.tokenEndpoint = n.token_endpoint, this.revocationEndpoint = n.revocation_endpoint, this.userInfoEndpoint = n.userinfo_endpoint, this.checkSessionIframe = n.check_session_iframe, this.issuer = n.issuer, this.endSessionEndpoint = n.end_session_endpoint;
  }
}
const L = {}, Sn = (e, n = new q()) => (s, t = "default") => (L[t] || (L[t] = new N(s, t, e, n)), L[t]), Tn = async (e) => {
  const { parsedTokens: n, callbackPath: s, extras: t, scope: o } = await e.loginCallbackAsync();
  return e.timeoutId = J(e, n.expiresAt, t, o), { callbackPath: s };
}, vn = (e) => Math.floor(Math.random() * e), F = class F {
  constructor(n, s = "default", t, o = new q()) {
    this.initPromise = null, this.tryKeepExistingSessionPromise = null, this.loginPromise = null, this.loginCallbackPromise = null, this.loginCallbackWithAutoTokensRenewPromise = null, this.userInfoPromise = null, this.renewTokensPromise = null, this.logoutPromise = null;
    let i = n.silent_login_uri;
    n.silent_redirect_uri && !n.silent_login_uri && (i = `${n.silent_redirect_uri.replace("-callback", "").replace("callback", "")}-login`);
    let r = n.refresh_time_before_tokens_expiration_in_second ?? 120;
    r > 60 && (r = r - Math.floor(Math.random() * 40)), this.location = o ?? new q();
    const a = n.service_worker_update_require_callback ?? $e(this.location);
    this.configuration = {
      ...n,
      silent_login_uri: i,
      token_automatic_renew_mode: n.token_automatic_renew_mode ?? V.AutomaticBeforeTokenExpiration,
      monitor_session: n.monitor_session ?? !1,
      refresh_time_before_tokens_expiration_in_second: r,
      silent_login_timeout: n.silent_login_timeout ?? 12e3,
      token_renew_mode: n.token_renew_mode ?? z.access_token_or_id_token_invalid,
      demonstrating_proof_of_possession: n.demonstrating_proof_of_possession ?? !1,
      authority_timeout_wellknowurl_in_millisecond: n.authority_timeout_wellknowurl_in_millisecond ?? 1e4,
      logout_tokens_to_invalidate: n.logout_tokens_to_invalidate ?? [
        "access_token",
        "refresh_token"
      ],
      service_worker_update_require_callback: a,
      service_worker_activate: n.service_worker_activate ?? fn,
      demonstrating_proof_of_possession_configuration: n.demonstrating_proof_of_possession_configuration ?? Ve,
      preload_user_info: n.preload_user_info ?? !1
    }, this.getFetch = t ?? An, this.configurationName = s, this.tokens = null, this.userInfo = null, this.events = [], this.timeoutId = null, this.loginCallbackWithAutoTokensRenewAsync.bind(this), this.initAsync.bind(this), this.loginCallbackAsync.bind(this), this.subscribeEvents.bind(this), this.removeEventSubscription.bind(this), this.publishEvent.bind(this), this.destroyAsync.bind(this), this.logoutAsync.bind(this), this.renewTokensAsync.bind(this), this.initAsync(this.configuration.authority, this.configuration.authority_configuration);
  }
  subscribeEvents(n) {
    const s = vn(9999999999999).toString();
    return this.events.push({ id: s, func: n }), s;
  }
  removeEventSubscription(n) {
    const s = this.events.filter((t) => t.id !== n);
    this.events = s;
  }
  publishEvent(n, s) {
    this.events.forEach((t) => {
      t.func(n, s);
    });
  }
  static get(n = "default") {
    const s = typeof process > "u";
    if (!Object.prototype.hasOwnProperty.call(L, n) && s)
      throw Error(`OIDC library does seem initialized.
Please checkout that you are using OIDC hook inside a <OidcProvider configurationName="${n}"></OidcProvider> component.`);
    return L[n];
  }
  _silentLoginCallbackFromIFrame() {
    if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
      const n = this.location, s = ne(n.getCurrentHref());
      window.parent.postMessage(
        `${this.configurationName}_oidc_tokens:${JSON.stringify({ tokens: this.tokens, sessionState: s.session_state })}`,
        n.getOrigin()
      );
    }
  }
  _silentLoginErrorCallbackFromIFrame(n = null) {
    if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
      const s = this.location, t = ne(s.getCurrentHref());
      t.error ? window.parent.postMessage(
        `${this.configurationName}_oidc_error:${JSON.stringify({ error: t.error })}`,
        s.getOrigin()
      ) : window.parent.postMessage(
        `${this.configurationName}_oidc_exception:${JSON.stringify({ error: n == null ? "" : n.toString() })}`,
        s.getOrigin()
      );
    }
  }
  async silentLoginCallbackAsync() {
    try {
      await this.loginCallbackAsync(!0), this._silentLoginCallbackFromIFrame();
    } catch (n) {
      console.error(n), this._silentLoginErrorCallbackFromIFrame(n);
    }
  }
  async initAsync(n, s) {
    if (this.initPromise !== null)
      return this.initPromise;
    const t = async () => {
      if (s != null)
        return new se({
          authorization_endpoint: s.authorization_endpoint,
          end_session_endpoint: s.end_session_endpoint,
          revocation_endpoint: s.revocation_endpoint,
          token_endpoint: s.token_endpoint,
          userinfo_endpoint: s.userinfo_endpoint,
          check_session_iframe: s.check_session_iframe,
          issuer: s.issuer
        });
      const i = await I(this.configuration, this.configurationName) ? window.sessionStorage : null;
      return await nn(this.getFetch())(
        n,
        this.configuration.authority_time_cache_wellknowurl_in_second ?? 60 * 60,
        i,
        this.configuration.authority_timeout_wellknowurl_in_millisecond
      );
    };
    return this.initPromise = t(), this.initPromise.finally(() => {
      this.initPromise = null;
    });
  }
  async tryKeepExistingSessionAsync() {
    return this.tryKeepExistingSessionPromise !== null ? this.tryKeepExistingSessionPromise : (this.tryKeepExistingSessionPromise = dn(this), this.tryKeepExistingSessionPromise.finally(() => {
      this.tryKeepExistingSessionPromise = null;
    }));
  }
  async startCheckSessionAsync(n, s, t, o = !1) {
    await cn(this, L, this.configuration)(
      n,
      s,
      t,
      o
    );
  }
  async loginAsync(n = void 0, s = null, t = !1, o = void 0, i = !1) {
    return this.logoutPromise && await this.logoutPromise, this.loginPromise !== null ? this.loginPromise : (i ? this.loginPromise = an(
      window,
      this.configurationName,
      this.configuration,
      this.publishEvent.bind(this),
      this
    )(s, o) : this.loginPromise = yn(
      this.configurationName,
      this.configuration,
      this.publishEvent.bind(this),
      this.initAsync.bind(this),
      this.location
    )(n, s, t, o), this.loginPromise.finally(() => {
      this.loginPromise = null;
    }));
  }
  async loginCallbackAsync(n = !1) {
    if (this.loginCallbackPromise !== null)
      return this.loginCallbackPromise;
    const s = async () => {
      const t = await gn(this)(n), o = t.tokens;
      return this.tokens = o, await I(this.configuration, this.configurationName) || P(this.configurationName, this.configuration.storage).setTokens(o), this.publishEvent(F.eventNames.token_acquired, o), this.configuration.preload_user_info && await this.userInfoAsync(), {
        parsedTokens: o,
        state: t.state,
        callbackPath: t.callbackPath,
        scope: t.scope,
        extras: t.extras
      };
    };
    return this.loginCallbackPromise = s(), this.loginCallbackPromise.finally(() => {
      this.loginCallbackPromise = null;
    });
  }
  async generateDemonstrationOfProofOfPossessionAsync(n, s, t, o = {}) {
    const i = this.configuration, r = {
      ath: await Oe(n),
      ...o
    };
    if (await I(i, this.configurationName))
      return `DPOP_SECURED_BY_OIDC_SERVICE_WORKER_${this.configurationName}#tabId=${Se(this.configurationName)}`;
    const c = P(this.configurationName, i.storage), l = await c.getDemonstratingProofOfPossessionJwkAsync(), d = c.getDemonstratingProofOfPossessionNonce();
    return d && (r.nonce = d), await be(window)(
      i.demonstrating_proof_of_possession_configuration
    )(l, t, s, r);
  }
  loginCallbackWithAutoTokensRenewAsync() {
    return this.loginCallbackWithAutoTokensRenewPromise !== null ? this.loginCallbackWithAutoTokensRenewPromise : (this.loginCallbackWithAutoTokensRenewPromise = Tn(this), this.loginCallbackWithAutoTokensRenewPromise.finally(() => {
      this.loginCallbackWithAutoTokensRenewPromise = null;
    }));
  }
  userInfoAsync(n = !1, s = !1) {
    return this.userInfoPromise !== null ? this.userInfoPromise : (this.userInfoPromise = wn(this)(n, s), this.userInfoPromise.finally(() => {
      this.userInfoPromise = null;
    }));
  }
  async renewTokensAsync(n = null, s = null) {
    if (this.renewTokensPromise !== null)
      return this.renewTokensPromise;
    if (this.timeoutId)
      return U.clearTimeout(this.timeoutId), this.renewTokensPromise = Pe(this, !0, n, s), this.renewTokensPromise.finally(() => {
        this.renewTokensPromise = null;
      });
  }
  async destroyAsync(n) {
    return await mn(this)(n);
  }
  async logoutSameTabAsync(n, s) {
    this.configuration.monitor_session && this.configuration.client_id === n && s && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === s && (await this.destroyAsync("LOGGED_OUT"), this.publishEvent(k.logout_from_same_tab, { mmessage: "SessionMonitor", sub: s }));
  }
  async logoutOtherTabAsync(n, s) {
    this.configuration.monitor_session && this.configuration.client_id === n && s && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === s && (await this.destroyAsync("LOGGED_OUT"), this.publishEvent(k.logout_from_another_tab, { message: "SessionMonitor", sub: s }));
  }
  async logoutAsync(n = void 0, s = null) {
    return this.logoutPromise ? this.logoutPromise : (this.logoutPromise = pn(
      this,
      L,
      this.getFetch(),
      console,
      this.location
    )(n, s), this.logoutPromise.finally(() => {
      this.logoutPromise = null;
    }));
  }
};
F.getOrCreate = (n, s) => (t, o = "default") => Sn(n, s)(t, o), F.eventNames = k;
let N = F;
const $ = class $ {
  constructor(n) {
    this._oidc = n;
  }
  subscribeEvents(n) {
    return this._oidc.subscribeEvents(n);
  }
  removeEventSubscription(n) {
    this._oidc.removeEventSubscription(n);
  }
  publishEvent(n, s) {
    this._oidc.publishEvent(n, s);
  }
  static get(n = "default") {
    return new $(N.get(n));
  }
  tryKeepExistingSessionAsync() {
    return this._oidc.tryKeepExistingSessionAsync();
  }
  loginAsync(n = void 0, s = null, t = !1, o = void 0, i = !1) {
    return this._oidc.loginAsync(n, s, t, o, i);
  }
  logoutAsync(n = void 0, s = null) {
    return this._oidc.logoutAsync(n, s);
  }
  silentLoginCallbackAsync() {
    return this._oidc.silentLoginCallbackAsync();
  }
  renewTokensAsync(n = null, s = null) {
    return this._oidc.renewTokensAsync(n, s);
  }
  loginCallbackAsync() {
    return this._oidc.loginCallbackWithAutoTokensRenewAsync();
  }
  get tokens() {
    return this._oidc.tokens;
  }
  get configuration() {
    return this._oidc.configuration;
  }
  async generateDemonstrationOfProofOfPossessionAsync(n, s, t, o = {}) {
    return this._oidc.generateDemonstrationOfProofOfPossessionAsync(
      n,
      s,
      t,
      o
    );
  }
  async getValidTokenAsync(n = 200, s = 50) {
    const t = this._oidc, o = {
      getTokens: () => t.tokens,
      configuration: {
        token_automatic_renew_mode: t.configuration.token_automatic_renew_mode,
        refresh_time_before_tokens_expiration_in_second: t.configuration.refresh_time_before_tokens_expiration_in_second
      },
      renewTokensAsync: t.renewTokensAsync.bind(t)
    };
    return pe(o, n, s);
  }
  fetchWithTokens(n, s = !1) {
    return Ce(n, this._oidc, s);
  }
  async userInfoAsync(n = !1, s = !1) {
    return this._oidc.userInfoAsync(n, s);
  }
  userInfo() {
    return this._oidc.userInfo;
  }
};
$.getOrCreate = (n, s = new q()) => (t, o = "default") => new $(N.getOrCreate(n, s)(t, o)), $.eventNames = N.eventNames;
let me = $;
export {
  me as OidcClient,
  q as OidcLocation,
  V as TokenAutomaticRenewMode,
  z as TokenRenewMode,
  An as getFetchDefault,
  ne as getParseQueryStringFromLocation,
  En as getPath
};
